import React from 'react'
import './Navbar.css'
import { BsLinkedin, BsGithub } from "react-icons/bs"
import { GrMail } from "react-icons/gr"
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx"
import { useState } from 'react'

const Navbar = () => {
    const [mobile, setMobile] = useState(false);
    function goto(value) {
        window.scrollTo({
            top: value,
            behavior: 'smooth'
        })
        if (mobile) {
            setMobile(!mobile);
        }
    }
    return (
        <div className="outer">
            <div className='n_wrapper'>
                <div><RxHamburgerMenu onClick={() => setMobile(!mobile)} className='ham' /></div>
                <div className={mobile ? "MobileMenuShow" : "Mobilemenulist"}>
                    <RxCross1 style={{ fontSize: "30px", float: "right", padding: "10px", display: "block" }} onClick={() => setMobile(!mobile)} />
                    <ul>
                        <li onClick={() => goto(0)}>Home</li>
                        <li onClick={() => goto(500)}>About</li>
                        <li onClick={() => goto(900)}>Skills</li>
                        <li onClick={() => goto(3100)}>Projects</li>
                        <li onClick={() => goto(6730)}>Stats</li>
                        <li onClick={() => goto(7000)}>Contact</li>
                    </ul>
                </div>
                <div className="n_left">
                    <div className="n_name">Gulshan</div>
                    <div className="menulist">
                        <ul>
                            <li onClick={() => goto(0)}>Home</li>
                            <li onClick={() => goto(650)}>About</li>
                            <li onClick={() => goto(1000)}>Skills</li>
                            <li onClick={() => goto(1730)}>Projects</li>
                            <li onClick={() => goto(4330)}>Stats</li>
                            <li onClick={() => goto(4970)}>Contact</li>
                        </ul>
                    </div>
                </div>
                <div className="n_right">
                    <div className="iconsList">
                        <ul>
                            <li>
                                <a href="https://www.linkedin.com/in/gulshan-sharma-397172184/" target={"_blank"}><BsLinkedin /></a>
                            </li>
                            <li>
                                <a href="https://github.com/Gulshan7777" target={"_blank"}><BsGithub /></a>
                            </li>
                            <li>
                                <a href="mailto:sharmagulshan252@gmail.com" target={"_blank"}>
                                    <GrMail />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar